import { isBefore } from 'date-fns/isBefore'
import { isEqual } from 'date-fns/isEqual'
import { parseISO } from 'date-fns/parseISO'

interface MenuTimeslot {
  startTime: string
  ordersCloseTime?: string | null
}

export function getValidTimeslot(
  timeslotToCheck: string | null | undefined,
  menuTimeslots: readonly MenuTimeslot[],
  now = new Date(),
): string | undefined {
  // The legacy URL conversion can return null for malformed input.
  const requested =
    timeslotToCheck === undefined
      ? now
      : timeslotToCheck === null
        ? new Date(NaN)
        : parseISO(timeslotToCheck)
  const firstAvailableTimeslot = menuTimeslots.find((timeslot) =>
    isBefore(now, parseISO(timeslot.ordersCloseTime || '')),
  )
  // An explicit selection remains selected even after its ordering cutoff.
  const matchingTimeslot = menuTimeslots.find((timeslot) =>
    isEqual(parseISO(timeslot.startTime), requested),
  )
  return matchingTimeslot
    ? matchingTimeslot.startTime
    : firstAvailableTimeslot?.startTime || menuTimeslots[0]?.startTime
}
